import React from 'react';
import GenomicsPlatformLoader from '@stjudecloud/assets/loaders/genomics-platform-loader.svg';

function CloudSpinner(props) {
  return <img src={GenomicsPlatformLoader} alt="Genomics Platform Loader" {...props} />;
}

export default CloudSpinner;
